import React, { useState } from 'react';
import { Gauge, RotateCcw } from 'lucide-react';
import useSpeedTest, { DEFAULT_SIZE_BYTES } from '../../hooks/useSpeedTest';
import SpeedTestGauge from '../../components/common/SpeedTestGauge';
import SpeedTestStats from '../../components/common/SpeedTestStats';
import SpeedTestSizePicker from '../../components/common/SpeedTestSizePicker';
import { CARD } from '../../components/technical/TechnicalUI';
import useDarkReady from '../../theme/useDarkReady';

export default function TechnicalSpeedTestPage() {
  useDarkReady();
  const {
    phase, ping, jitter, downloadMbps, uploadMbps, liveMbps,
    downloadPingIncrease, uploadPingIncrease, error, run, cancel,
  } = useSpeedTest();
  const [size, setSize] = useState(DEFAULT_SIZE_BYTES);
  const running = phase === 'ping' || phase === 'download' || phase === 'upload';

  return (
    <div>
      <h2 style={{ fontSize: '1.1rem', fontWeight: 700, marginBottom: 2 }}>Speed Test</h2>
      <p style={{ color: 'var(--c-6b7280)', fontSize: '.8rem', marginBottom: 16 }}>Check real internet speed at this location</p>

      <div style={{ ...CARD, padding: '26px 18px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20 }}>
        <SpeedTestGauge phase={phase} liveMbps={liveMbps} />

        <SpeedTestSizePicker value={size} onChange={setSize} disabled={running} />

        {phase !== 'idle' && phase !== 'error' && (
          <SpeedTestStats
            ping={ping} downloadMbps={downloadMbps} uploadMbps={uploadMbps}
            downloadPingIncrease={downloadPingIncrease} uploadPingIncrease={uploadPingIncrease}
          />
        )}
        {phase === 'done' && jitter != null && (
          <p style={{ fontSize: '.72rem', color: 'var(--c-6b7280)', margin: 0 }}>Jitter: {jitter} ms</p>
        )}
        {error && <p style={{ color: 'var(--c-dc2626)', fontSize: '.85rem', margin: 0 }}>{error}</p>}

        <button
          className="btn btn-primary"
          style={{ width: '100%', justifyContent: 'center' }}
          onClick={running ? cancel : () => run(size)}
        >
          {running ? 'Cancel' : (
            <>
              {phase === 'done' || phase === 'error' ? <RotateCcw size={15} /> : <Gauge size={15} />}
              {phase === 'done' || phase === 'error' ? 'Test Again' : 'Start Test'}
            </>
          )}
        </button>
      </div>
    </div>
  );
}
